<div class="mb-2 fw-bold">
  Add Job
  <span class="cursor-pointer">
    {{ selectedJobType?.name ? " > " + selectedJobType?.name : "" }}</span
  >
</div>
<div class="row row-cols-1 row-cols-lg-2">
  <div class="col mb-5">
    <!-- Form begins -->
    <form [formGroup]="responseFormData">
      <!-- Site name input -->

      <div class="row row-cols-2 my-3">
        <div class="col">
          <button
            type="button"
            class="btn btn-lg btn-dark w-100"
            [routerLink]="['/jobs']"
            [queryParams]="{ cancel: true }"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          <button
            type="button"
            class="btn btn-primary btn-lg w-100"
            [disabled]="!responseJobType.site.data || addJobPressed"
            (click)="onAddJob()"
          >
            Add Job
          </button>
        </div>
      </div>
      <div class="d-flex flex-column gap-2">
        <div class="form-floating">
          <!--alarm received time-->
          <input
            type="datetime-local"
            class="form-control"
            placeholder="Alarm Received"
            [(ngModel)]="responseJobType.rat.value"
            [ngModelOptions]="{ standalone: true }"
            (change)="formatReceivedAtDatetime($event)"
          />
          <label>Alarm Received</label>
        </div>
        @if (responseJobType.site.data?.id) {
          <dl class="d-flex align-items-center p-1">
            <div class="flex-grow-1">
              <dt>Site</dt>
              <dd>
                {{ responseJobType.site.value }}
                <div>[{{ responseJobType.client.value }}]</div>
              </dd>
            </div>

            <span (click)="editField('site')" class="edit-button"> </span>
          </dl>
          @if (
            selectedSiteExtraDetails?.additional_info?.priority_info?.notes
          ) {
            <dl>
              <dt>Priority Alarm Response Site</dt>
              <dd class="gt-multi-line mb-3 overflow-25vh text-danger">
                {{
                  selectedSiteExtraDetails?.additional_info?.priority_info
                    ?.notes
                }}
              </dd>
            </dl>
          }
        } @else {
          <gtapp-auto-complete
            [data]="siteList"
            placeHolder="Select Site"
            searchKeyword="company_name"
            [initialValue]="responseFormData.value.siteName"
            [itemTemplate]="siteTemplate"
            [addInitialKey]="isAdmin || isDispatchUser"
            (inputChanged)="onSiteSearch($event)"
            (selected)="onSelectSite($event)"
            [inputId]="'siteId'"
            [enableCloseOption]="true"
            (fieldCleared)="editField('site')"
          >
          </gtapp-auto-complete>
          <ng-template #siteTemplate let-item>
            @if (item?.key === 0) {
              <div>Create New Site</div>
            } @else {
              <div>
                <div class="fw-medium">
                  {{ item?.company_name }} [{{ item?.company?.company_name }}]
                </div>

                <div class="small-font text-secondary">
                  {{ item?.address?.full_address }}
                </div>
              </div>
            }
          </ng-template>
        }
        @if (responseJobType.site.data) {
          <!-- Monitoring Company -->
          @if (responseJobType.mc.data?.id) {
            <dl class="d-flex align-items-center p-1">
              <div class="flex-grow-1">
                <dt>Monitoring Company</dt>
                <dd>
                  {{ responseJobType.mc.value }}
                </dd>
              </div>

              <span (click)="editField('mc')" class="edit-button"> </span>
            </dl>
          } @else {
            <gtapp-auto-complete
              [data]="monitoringCompanyList"
              placeHolder="Monitoring Company"
              searchKeyword="company_name"
              [initialValue]="responseFormData.value.monitoringCompanyName"
              [itemTemplate]="MCTemplate"
              [addInitialKey]="isAdmin && responseJobType.mc.tempValue"
              (inputChanged)="onMcSearch($event)"
              (selected)="onMonitoringSelect($event)"
              [inputId]="'mcId'"
              [enableCloseOption]="true"
              (fieldCleared)="editField('mc')"
            >
            </gtapp-auto-complete>
            <ng-template #MCTemplate let-item>
              @if (item?.key === 0) {
                <div>Add Monitoring Company</div>
              } @else {
                <div>
                  {{ item.company_name }}
                </div>
              }
            </ng-template>
          }
          <!--sub biller field-->
          <div class="row row-cols-1 row-cols-lg-2">
            <div class="col">
              @if (selectedSiteExtraDetails?.sub_biller?.id) {
                <dl class="d-flex align-items-center p-1">
                  <div class="flex-grow-1">
                    <dt>Sub Biller</dt>
                    <dd>
                      {{ selectedSiteExtraDetails?.sub_biller?.company_name }}
                    </dd>
                  </div>

                  <span (click)="editField('sb')" class="edit-button"> </span>
                </dl>
              } @else {
                <gtapp-auto-complete
                  [data]="subBillerListData"
                  placeHolder="Sub Biller"
                  searchKeyword="company_name"
                  inputId="subBillerLookupFieldId"
                  [itemTemplate]="subBillerLookupTemplate"
                  [addInitialKey]="isAdmin && responseJobType.sb.tempValue"
                  (inputChanged)="onSubBillerLookup($event)"
                  (selected)="onSelectSubBiller($event)"
                  [enableCloseOption]="true"
                  (fieldCleared)="editField('sb')"
                >
                </gtapp-auto-complete>
                <ng-template #subBillerLookupTemplate let-item>
                  @if (item?.key === 0) {
                    <div>Add Sub Biller</div>
                  } @else {
                    <div>
                      {{ item.company_name }}
                    </div>
                  }
                </ng-template>
              }
            </div>
            <div class="col">
              <dl>
                <div class="form-floating">
                  <input
                    class="form-control"
                    id="jobNumber"
                    type="text"
                    placeholder="Job Number"
                    formControlName="externalJobId"
                    autocomplete="off"
                  />
                  <label>Job Number</label>
                </div>
              </dl>
            </div>
          </div>

          <!-- Selected Site Keys Info-->
          <div>
            @if (responseJobType.site.data?.id) {
              <gtapp-site-keys
                [selectedSite]="responseJobType.site.data"
                (updateSiteInfo)="siteKeyInternalCheck($event)"
              ></gtapp-site-keys>
            }
          </div>
          @if (siteKeyList?.length) {
            <dl>
              <label>
                <input
                  class="form-check-input"
                  type="checkbox"
                  [checked]="sealInfo?.internal_check"
                  (change)="
                    sealInfo?.internal_check
                      ? (sealInfo = {})
                      : (sealInfo.internal_check = true)
                  "
                />
                Internal Check (Seal) Required</label
              >
            </dl>
          }
          <!-- Assign Guard -->
          @if (selectedJobType.enable_assignees === true) {
            <div>
              @if (responseJobType.assignee.data?.id) {
                <dl class="d-flex align-items-center p-1">
                  <div class="flex-grow-1">
                    <dt>Assigned To</dt>
                    <dd>
                      <span
                        [gtappPopover]="userDetailPopoverTemplate"
                        [popoverData]="{
                          userId: responseJobType.assignee.data?.id,
                        }"
                      >
                        {{ responseFormData.value.assigneeName }}</span
                      >
                    </dd>
                  </div>

                  <span (click)="editField('assignee')" class="edit-button">
                  </span>
                </dl>
              } @else {
                <gtapp-auto-complete
                  [data]="assigneeList"
                  placeHolder="Assign To"
                  searchKeyword="full_name"
                  [initialValue]="responseFormData.value.assigneeName"
                  [itemTemplate]="assigneeTemplate"
                  (inputChanged)="onAssigneeSearch($event)"
                  (selected)="onAssigneeSelect($event)"
                  [inputId]="'assigneeId'"
                  [enableCloseOption]="true"
                  (fieldCleared)="editField('assignee')"
                >
                </gtapp-auto-complete>
                <ng-template #assigneeTemplate let-item>
                  <div class="d-flex gap-2 flex-wrap">
                    <span>
                      {{ item?.full_name }}
                    </span>
                    @if (item?.access_status === 2) {
                      <div
                        class="text-warning-emphasis small-font bg-white rounded my-auto border px-2 fw-semibold"
                      >
                        Casual
                      </div>
                    }
                    @if (
                      selectedSiteExtraDetails?.preferred_user_ids?.includes(
                        item?.id
                      )
                    ) {
                      <div
                        class="text-success-emphasis small-font bg-white rounded my-auto border px-2 fw-semibold"
                      >
                        Preferred
                      </div>
                    }
                  </div>
                  @if (selectedSiteExtraDetails?.last_assignees?.[item?.id]) {
                    <div class="small text-secondary">
                      Previously Assigned:
                      @if (
                        (selectedSiteExtraDetails?.last_assignees?.[item?.id]
                          | misc: "getXDaysAgo") > 1
                      ) {
                        {{
                          selectedSiteExtraDetails?.last_assignees?.[item?.id]
                            | misc: "getXDaysAgo"
                        }}
                        day(s) ago |
                      } @else {}
                      {{
                        selectedSiteExtraDetails?.last_assignees?.[item?.id]
                          | misc: "eventDateGrouping"
                      }}
                    </div>
                  }
                  @if (item?.subcontractors?.length) {
                    <div class="small text-secondary">
                      🟧Subcontractor:
                      <span class="subcontractor-name">{{
                        item?.subcontractors
                      }}</span>
                    </div>
                  }
                </ng-template>
              }
            </div>
          }
          <!-- Response Type -->
          @if (responseJobType.rt.data?.id) {
            <dl class="d-flex align-items-center p-1">
              <div class="flex-grow-1">
                <dt>Response Type</dt>
                <dd>
                  {{ responseJobType.rt.value }}
                </dd>
              </div>

              <span (click)="editField('rt')" class="edit-button"> </span>
            </dl>
          } @else {
            <gtapp-auto-complete
              [data]="responseTypeList"
              placeHolder="Select Response Type"
              searchKeyword="name"
              [initialValue]="responseFormData.value.responseTypeName"
              [itemTemplate]="responseTypeTemplate"
              [addInitialKey]="isAdmin && responseJobType.rt.tempValue"
              (inputChanged)="onRtSearch($event)"
              (selected)="onResponseTypeSelect($event)"
              [inputId]="'rtId'"
              [enableCloseOption]="true"
              (fieldCleared)="editField('rt')"
            >
            </gtapp-auto-complete>
            <ng-template #responseTypeTemplate let-item>
              @if (item?.key === 0) {
                <div>Add Response Type</div>
              } @else {
                <div>
                  {{ item.name }}
                </div>
              }
            </ng-template>
          }

          <!-- <div class="row mb-3">
            <div class="col">
              <button
                (click)="openAddMobileFormTemplate()"
                class="btn w-100"
                [ngClass]="
                  selectedPromptIds?.length
                    ? 'btn-primary'
                    : 'btn-outline-primary'
                "
              >
                Add Mobile Form
              </button>
            </div>
          </div> -->

          <div>
            @if (largeView) {
              <div class="d-flex gap-1">
                <div class="form-group input-group">
                  <textarea
                    class="form-control"
                    placeholder="Additional Information"
                    rows="5"
                    wrap="hard"
                    maxlength="900"
                    type="text"
                    autofocus
                    [(ngModel)]="responseJobType.ai.value"
                    formControlName="requestDetail"
                    id="aiTextBox"
                  ></textarea>
                  @if (responseJobType?.ai?.value) {
                    <span
                      class="input-group-text"
                      (click)="
                        responseJobType.ai.value = '';
                        responseFormData.controls['requestDetail'].setValue('');
                        shiftFocus('aiTextBox')
                      "
                    >
                      <i class="fa-solid fa-xmark"></i>
                    </span>
                  }
                </div>
                <div class="form-group input-group">
                  <textarea
                    class="form-control"
                    placeholder="Internal Notes (Will not be shown on reports)"
                    rows="5"
                    wrap="hard"
                    maxlength="900"
                    type="text"
                    autofocus
                    [(ngModel)]="responseJobType.in.value"
                    formControlName="internal_notes"
                    id="inTextBox"
                  ></textarea>
                  @if (responseJobType?.in?.value) {
                    <span
                      class="input-group-text"
                      (click)="
                        responseJobType.in.value = '';
                        responseFormData.controls['internal_notes'].setValue(
                          ''
                        );
                        shiftFocus('inTextBox')
                      "
                    >
                      <i class="fa-solid fa-xmark"></i>
                    </span>
                  }
                </div>
              </div>
            } @else {
              <div class="col">
                <div class="mb-3">
                  <button
                    (click)="openTemplate(jobExtraInfoTempalte, 'ai')"
                    class="btn btn-lg w-100"
                    [ngClass]="
                      responseJobType.ai.value ? 'btn-info' : 'btn-outline-info'
                    "
                  >
                    Additional Information
                  </button>
                </div>
                <div>
                  <button
                    (click)="openTemplate(jobExtraInfoTempalte, 'in')"
                    class="btn btn-lg w-100"
                    [ngClass]="
                      responseJobType.in.value ? 'btn-info' : 'btn-outline-info'
                    "
                  >
                    Internal Notes
                  </button>
                </div>
              </div>
            }
          </div>
          <!-- Final actions -->
          @if (responseJobType.oc.data?.id) {
            <dl class="d-flex align-items-center p-1">
              <div class="flex-grow-1">
                <dt>Site Contact</dt>
                <dd>
                  {{ responseJobType.oc.value }}
                </dd>
              </div>

              <span (click)="editField('oc')" class="edit-button"> </span>
            </dl>
          } @else {
            <gtapp-auto-complete
              [data]="siteContacts"
              placeHolder="Onsite Contact (Optional)"
              searchKeyword="full_name"
              [initialValue]="responseFormData.value.siteContactName"
              [itemTemplate]="siteContactSearch"
              [addInitialKey]="true"
              (selected)="selectContact($event)"
              [inputId]="'ocId'"
              [enableCloseOption]="true"
              (fieldCleared)="editField('oc')"
            >
            </gtapp-auto-complete>
            <ng-template #siteContactSearch let-item>
              @if (item?.key === 0) {
                @if (isAdmin && responseJobType.site.data) {
                  <div>Add New Contact</div>
                }
              } @else {
                <div>
                  {{ item?.full_name }}
                </div>
              }
            </ng-template>
          }

          <div class="row row-cols-2 my-3">
            <div class="col">
              <button
                type="button"
                class="btn btn-lg btn-dark w-100"
                [routerLink]="['/jobs']"
                [queryParams]="{ cancel: true }"
              >
                Cancel
              </button>
            </div>
            <div class="col">
              <button
                type="button"
                class="btn btn-primary btn-lg w-100"
                [disabled]="!responseJobType.site.data || addJobPressed"
                (click)="onAddJob()"
              >
                Add Job
              </button>
            </div>
          </div>
        }
      </div>
    </form>
  </div>

  <div class="col">
    @if (
      showSiteMap &&
      (responseJobType.site?.data?.address?.latitude ||
        responseJobType.site?.data?.gps?.lat) &&
      (responseJobType.site?.data?.address?.longitude ||
        responseJobType.site?.data?.gps?.lon) &&
      largeView
    ) {
      <div>
        <gtapp-map-leaflet
          [latLon]="{
            lat:
              responseJobType.site?.data?.address?.latitude ||
              responseJobType.site?.data?.gps?.lat,
            lon:
              responseJobType.site?.data?.address?.longitude ||
              responseJobType.site?.data?.gps?.lon,
          }"
          [mapId]="'largeJob'"
        ></gtapp-map-leaflet>
      </div>
    }
  </div>
</div>

<!-- Additional Information/ Internal Notes POPOVER / DIALOG -->
<ng-template
  #jobExtraInfoTempalte
  let-data
  let-jobExtraInfoTempalte="dialogRef"
>
  <div class="dialog-box card">
    <div class="card-header">
      {{ data === "ai" ? "Additional Information " : "Internal Notes" }}
    </div>

    <!-- Request Detail Section start-->
    @if (data === "in") {
      <div class="small mb-3">Will not be shown on reports</div>
    }

    <div class="form-group input-group">
      <textarea
        class="form-control"
        [placeholder]="
          data === 'ai' ? 'Additional Information ' : 'Internal Notes'
        "
        rows="5"
        wrap="hard"
        maxlength="900"
        type="text"
        autofocus
        [(ngModel)]="responseJobType[data].value"
        id="aiTextBox"
      ></textarea>
      @if (responseJobType?.[data]?.value) {
        <span
          class="input-group-text"
          (click)="responseJobType[data].value = ''; shiftFocus('aiTextBox')"
        >
          <i class="fa-solid fa-xmark"></i>
        </span>
      }
    </div>

    <div class="row my-2">
      <div class="col">
        <button
          class="btn btn-lg w-100"
          [ngClass]="
            responseJobType?.[data]?.value ? 'btn-primary' : 'btn-dark'
          "
          (click)="jobExtraInfoTempalte.close(); updateJobExtraInfo(data)"
        >
          {{ responseJobType?.[data]?.value ? "Save" : "Close" }}
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template
  #prioritySiteInfoTemplate
  let-data
  let-prioritySiteInfoTemplateRef="dialogRef"
>
  <div class="dialog-box card">
    <div class="card-header fw-semibold">Priority Alarm Response Site</div>
    <div class="p-3 border border-danger text-danger bg-white rounded fs-5">
      <div class="gt-multi-line mb-3 overflow-45vh">
        {{ selectedSiteExtraDetails?.additional_info?.priority_info?.notes }}
      </div>
    </div>

    <div
      class="d-flex align-items-center my-3 justify-content-center fw-semibold fs-5"
    >
      <input
        type="checkbox"
        id="prioritySiteSelection"
        [checked]="data?.read"
        (change)="data.read = !data?.read"
      /><label class="ms-2" for="prioritySiteSelection" role="button"
        >I have read and understood the above</label
      >
    </div>

    @if (data.read) {
      <div class="row">
        <div class="col">
          <button
            class="btn btn-lg w-100 btn-primary"
            [disabled]="!data?.read"
            (click)="prioritySiteInfoTemplateRef.close()"
          >
            OK
          </button>
        </div>
      </div>
    }
  </div>
</ng-template>
